/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tut_Jadwal_S3Inputs */

const en_tut_jadwal_s3 = /** @type {(inputs: Tut_Jadwal_S3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Shortly before the start, a reminder appears as a banner in the corner and as a row in the Inbox. Press **Buka rapat** to go straight in, or **Tutup** to mark it read.`)
};

const id_tut_jadwal_s3 = /** @type {(inputs: Tut_Jadwal_S3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Menjelang mulai, pengingat muncul sebagai banner di pojok layar dan sebagai baris di Inbox. Tekan **Buka rapat** untuk langsung masuk, atau **Tutup** untuk menandainya sudah dibaca.`)
};

/**
* | output |
* | --- |
* | "Shortly before the start, a reminder appears as a banner in the corner and as a row in the Inbox. Press **Buka rapat** to go straight in, or **Tutup** to mar..." |
*
* @param {Tut_Jadwal_S3Inputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const tut_jadwal_s3 = /** @type {((inputs?: Tut_Jadwal_S3Inputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tut_Jadwal_S3Inputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_tut_jadwal_s3(inputs)
	return en_tut_jadwal_s3(inputs)
});